module.exports = __webpack_public_path__ + "static/media/profile.ef1ae8c4.svg";